import store from "@/store";
import FEATURES from "@/common/feature-lib";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/Dashboard",
	component: () => import("@/views/Dashboard/DashboardRouteView"),
	beforeEnter: (to, from, next) => {
		if (!store.getters.currentUserHasFeature(FEATURES.DASHBOARD)) {
			next({
				name: "Unauthorized"
			});
		}
		next();
	},
	children: [
		{
			path: "/",
			component: () => import("@/views/Dashboard/DashboardDetailsRouteView"),
			meta: {
				breadcrumb: "Dashboard",
				authorizedRoles: [
					PERMISSIONS.ESS_VIEW,
					PERMISSIONS.RSU_VIEW,
					PERMISSIONS.TSC_VIEW,
					PERMISSIONS.TOTAL_STATION_VIEW
				]
			},
			children: [
				{
					path: "/",
					name: "Dashboard",
					component: () => import("@/views/Dashboard/DashboardEntryPoint")
				},
				{
					path: "TotalStationsStatus/:totalStationStatusId",
					name: "Dashboard.Details.TotalStationsStatus",
					component: () => import("@/views/Dashboard/Details/DetailsStatusTs"),
					meta: {
						breadcrumb: "Total Stations Status"
					}
				},
				{
					path: "RsusStatus/:deviceStatusId",
					name: "Dashboard.Details.RsusStatus",
					component: () => import("@/views/Dashboard/Details/DetailsStatusRsu"),
					meta: {
						breadcrumb: "Devices Status"
					}
				},
				{
					path: "TscsStatus/:deviceStatusId",
					name: "Dashboard.Details.TscsStatus",
					component: () => import("@/views/Dashboard/Details/DetailsStatusTsc"),
					meta: {
						breadcrumb: "Devices Status"
					}
				},
				{
					path: "EsssStatus/:deviceStatusId",
					name: "Dashboard.Details.EsssStatus",
					component: () => import("@/views/Dashboard/Details/DetailsStatusEss"),
					meta: {
						breadcrumb: "Devices Status"
					}
				}
			]
		}
	]
};
